import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetLandOrderListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    orderDateStart: string | undefined
    orderDateEnd: string | undefined
    loadingDateStart: string | undefined
    loadingDateEnd: string | undefined
    deliverDateStart: string | undefined
    deliverDateEnd: string | undefined
    selectedCustomers: CustomMultiSelectModel[]
    selectedSuppliers: CustomMultiSelectModel[]
    selectedLoadingCountry: CustomSingleSelectModel | undefined
    selectedLoadingCounty: CustomSingleSelectModel | undefined
    selectedUnloadingCountry: CustomSingleSelectModel | undefined
    selectedUnloadingCounty: CustomSingleSelectModel | undefined
    selectedOrderStatuss: CustomMultiSelectModel[]
    selectedVehicles: CustomMultiSelectModel[]
    selectedTrailers: CustomMultiSelectModel[]
    selectedOperationTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetLandOrderListPagingAndFilterRequest: GetLandOrderListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    orderDateStart: undefined,
    orderDateEnd: undefined,
    loadingDateEnd: undefined,
    loadingDateStart: undefined,
    deliverDateStart: undefined,
    deliverDateEnd: undefined,
    selectedCustomers: [],
    selectedSuppliers: [],
    selectedLoadingCountry: undefined,
    selectedLoadingCounty: undefined,
    selectedUnloadingCountry: undefined,
    selectedUnloadingCounty: undefined,
    selectedOrderStatuss: [],
    selectedVehicles: [],
    selectedTrailers: [],
    selectedOperationTypes: [],
    columnFilters: []
}